// hooks/support/tasks/useTasksUnreadCount.ts
import { useState, useEffect } from "react";
import useToken from "../../auth/useToken";
import useAuth from "../../auth/useAuth";
import { taskService } from "../../../services/support/taskService";

export default function useTasksUnreadCount() {
  const { token } = useToken();
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!token || !user?.id) return;
    let cancelled = false;

    const refresh = async () => {
      try {
        const c = await taskService.getUnreadCount(token, user.id);
        if (!cancelled) setCount(Number(c) || 0);
      } catch (err) {
        console.error(err);
      }
    };

    refresh();
    const id = window.setInterval(refresh, 30000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [token, user?.id]);

  return { count };
}
